import * as React from 'react';
import { observer, inject } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import { verticalAlign } from '../utils/customPropStyles';
import { imageError } from '../utils/imageError';

const Image = styled<any, any>('img')`
    ${propStyles};
    ${verticalAlign};
    flex-shrink: 0;
`;

interface Icon {
    theme?: any;
    dataStore?: any;
    fileName: string;
}

const Icon: React.SFC<Icon> = ({
    theme,
    dataStore,
    fileName = '',
    ...props
}) => {
    let src = `${dataStore.apiUrl}/${fileName}`;
    // check if extension exists. Handles cases with no extension and files with '.' at the start of the name.
    const ext = fileName.slice(
        (Math.max(0, fileName.lastIndexOf('.')) || Infinity) + 1
    );
    // appened .svg if no extension
    if (!ext) {
        src += '.svg';
    }

    return <Image src={src} onError={e => imageError(e.target)} {...props} />;
};

export default inject('dataStore')(withTheme(observer(Icon))) as any;



// WEBPACK FOOTER //
// ./src/Components/Icon.tsx